import { ProfilesListMode } from "PFApp/activities/types/profiles_view_mode";
import { TemplateKey } from "PFApp/constants/templates";
import { TableColumn } from "PFTypes";
import { Id } from "PFTypes";
import { createContext, useContext } from "react";

export type ActivityShowContextType = {
  activityId: Id;
  isAudit: boolean;
  isEngagement: boolean;
  isRole: boolean;
  roleKey: TemplateKey.Role | TemplateKey.AuditRole;
  isFillDisabled: boolean;

  // Profiles list mode and columns
  profilesListMode: ProfilesListMode;
  setProfilesListMode: React.Dispatch<React.SetStateAction<ProfilesListMode>>;
  availableProfilesListColumns: TableColumn[];
  selectedProfilesListColumns: TableColumn[];
  setSelectedProfilesListColumns: React.Dispatch<React.SetStateAction<TableColumn[]>>;
};

const activityShowContextPlaceholder: ActivityShowContextType = {
  //@ts-ignore-line activityId is always provided in LoadedActivity
  activityId: null,
  isAudit: false,
  isEngagement: false,
  isRole: false
};

const ActivityShowContext = createContext<ActivityShowContextType>(activityShowContextPlaceholder);

export const useActivityShowContext = () => useContext(ActivityShowContext);

export default ActivityShowContext;
